import PropTypes from "prop-types";

export const tabProps = {
  editItem: PropTypes.object,
  setEditItem: PropTypes.func,
  form: PropTypes.object,
  setData: PropTypes.func,
  iframe: PropTypes.string,
  setIframe: PropTypes.func,
  data: PropTypes.object,
};
